import Header from "../components/Header";
import Footer from "../components/Footer";
import Head from "../components/Head";
import Script from "next/script";
import * as common from "../common/commonFunction";
import commonSession from "../common/commonSession";
import AWS, { DataExchange } from "aws-sdk";
import { useState, useEffect } from "react";
import moment from "moment";
import sha1 from "sha1";
import $ from "jquery";
import axios from "axios";
import { isMobile } from "react-device-detect";

const RegistrationCorp = () => {
  // get today date
  const current = new Date();
  const today_day = current.getDate();
  const today_month = current.getMonth() + 1;
  const today_year = current.getFullYear();
  const next_year = today_year + 1;

  const [nickName, setNickName] = useState("");
  const [userMail, setUserMail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [pw_cf, setPwcf] = useState("");
  const [selectCountry, setSelectCountry] = useState("KR");
  const [callNumber, setCallNumber] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [inviterEmail, setInviterEmail] = useState(null);
  const [isIdentified, setIsIdentified] = useState(true);
  const [file, setFile] = useState([]);
  const [uploadUrl, setUploadUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [inviterEmailVerify, setInviterEmailVerify] = useState("");

  const handleChange = (e) => {
    $(".invalid-feedback").hide();
    e.target.classList.remove("error");
    e.target.classList.add("success");

    if (e.target.name == "nickName") {
      setNickName(e.target.value);
    } else if (e.target.name == "inviterEmail") {
      setInviterEmail(e.target.value);
    } else if (e.target.name == "callNumber") {
      setCallNumber(e.target.value);
    } else if (e.target.name == "code") {
      setCode(e.target.value);
    } else if (e.target.name == "businessNumber") {
      setBusinessNumber(e.target.value);
    } else if (e.target.name == "userMail") {
      setUserMail(e.target.value);
    } else if (e.target.name == "pw") {
      setPw(e.target.value);

      if (e.target.value != pw_cf) {
        $(".invalid-feedback.pw_cf").show();
        e.target.classList.remove("success");
        e.target.classList.add("error");
        $("#pw").focus();
      }
    } else if (e.target.name == "pw_cf") {
      setPwcf(e.target.value);

      if (e.target.value != pw) {
        $(".invalid-feedback.pw_cf").show();
        e.target.classList.remove("success");
        e.target.classList.add("error");
        $("#pw_cf").focus();
      } else {
        $("#pw").removeClass("error");
        $("#pw").addClass("success");
        $("#pw_cf").removeClass("error");
        $("#pw_cf").addClass("success");
      }
    }
  };

  // join function
  const joinFunc = () => {
    var flag = true;
    $(".invalid-feedback").hide();

    if (nickName == "") {
      flag = false;
      $(".invalid-feedback.nickName").show();
      $("#nickname").removeClass("success");
      $("#nickname").addClass("error");
      $("#nickname").focus();
    }

    if (pw == "") {
      flag = false;
      $(".invalid-feedback.pw").show();
      $("#pw").removeClass("success");
      $("#pw").addClass("error");
      $("#pw").focus();
    }

    if (pw != pw_cf) {
      flag = false;
      $(".invalid-feedback.pw_cf").show();
      $("#pw_cf").removeClass("success");
      $("#pw_cf").addClass("error");
      $("#pw_cf").focus();
    } else {
      $("#pw").removeClass("error");
      $("#pw").addClass("success");
      $("#pw_cf").removeClass("error");
      $("#pw_cf").addClass("success");
    }

    if (businessNumber == "") {
      flag = false;
      $(".invalid-feedback.biz_number").show();
      $("#businessNumber").removeClass("success");
      $("#businessNumber").addClass("error");
      $("#businessNumber").focus();
    }

    if (file == "") {
      flag = false;
      $(".invalid-feedback.biz_file").show();
      $("#file").removeClass("success");
      $("#file").addClass("error");
      $("#file").focus();
    }

    if (callNumber == "") {
      flag = false;
      $(".invalid-feedback.biz_call").show();
      $("#callNumber").removeClass("success");
      $("#callNumber").addClass("error");
      $("#callNumber").focus();
    }

    var nickFlag = $(".nickCheckBtn").css("display");

    if (nickFlag != "none") {
      flag = false;
      alert("닉네임 중복확인을 진행해주세요.");
      $("#nickname").removeClass("success");
      $("#nickname").addClass("error");
      $("#nickName").focus();
    }

    var emailVerify = $(".sendEmail").css("display");

    if (emailVerify != "none") {
      flag = false;
      alert("이메일 인증을 진행해주세요");
      $("#userMail").removeClass("success");
      $("#userMail").addClass("error");
      $("#userMail").focus();
    }

    $('input[type="checkbox"]').each(function (i, e) {
      if ($(e).prop("required")) {
        if (!$(e).is(":checked")) {
          $(e).focus();
          alert("필수항목을 체크해주세요!");
          flag = false;
        }
      }
    });

    if (flag) {
      const option = {
        url: "/users/register/ent",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data"
        },
        data: {
          email: userMail,
          nickName: nickName,
          callNumber: callNumber,
          password: pw,
          countryCode: selectCountry,
          isIdentified: isIdentified,
          inviterEmail: inviterEmail,
          file: file,
          businessNumber: businessNumber
        }
      };

      axios(option)
        .then((result) => {
          if (result.data.status == 200) {
            $(".toast .toast-body").html(
              nickName + "님 환영합니다!\n로그인을 해주세요 :-)"
            );
            $(".toast").show();
            $(".toast").css("opacity", 1);

            setTimeout(() => {
              location.replace("/login");
            }, 3000);
          } else if (
            result.data.status == "501" ||
            result.data.status == "502"
          ) {
            $(".toast .toast-body").html(result.message);
            $(".toast").show();
            $(".toast").css("opacity", 1);

            setTimeout(() => {
              $(".toast").hide();
            }, 3000);

            $(".modal").hide();
            return false;
          } else {
            $(".toast .toast-body").html(result.data.codeMsg);
            $(".toast").show();
            $(".toast").css("opacity", 1);
            setTimeout(() => {
              $(".toast").hide();
            }, 3000);
            $(".modal").hide();
            return false;
          }
        })
        .catch((error) => {
          $(".toast .toast-body").html(
            "서버 연결 도중 에러가 났습니다. 다시 시도해 주십시오."
          );
          $(".toast").show();
          $(".toast").css("opacity", 1);
          setTimeout(() => {
            $(".toast").hide();
          }, 3000);
          return false;
        });
    }
  };

  // 추천인아이디 존재 여부
  const checkInviterEmail = () => {
    const option = {
      url: "/users/checkInviter?inviterEmail=" + inviterEmail,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      }
    };

    axios(option)
      .then((result) => {
        if (result.data.status == 200) {
          $(".toast .toast-body").html("입력 가능한 추천인 아이디 입니다.");
          $(".toast").show();
          $(".toast").css("opacity", 1);

          setTimeout(() => {
            $(".toast").hide();
          }, 4000);

          setInviterEmailVerify("Y");
        } else {
          $(".toast .toast-body").html(result.data.message);
          $(".toast").show();
          $(".toast").css("opacity", 1);

          setTimeout(() => {
            $(".toast").hide();
          }, 4000);

          setInviterEmail("");
          $('[name="inviterEmailVerify"]').val("");
          return false;
        }
      })
      .catch((error) => {
        $(".toast .toast-body").html(
          "서버 연결 도중 에러가 났습니다. 다시 시도해 주십시오."
        );
        $(".toast").show();
        $(".toast").css("opacity", 1);
        setTimeout(() => {
          $(".toast").hide();
        }, 3000);
        return false;
      });
  };

  // 사업자등록증 정보
  const handleFileInput = (e) => {
    var maxSize = 5 * 1024 * 1024;
    var fileSize = e.target.files[0].size;

    if (fileSize > maxSize) {
      alert("최대 업로드 용량은 5MB입니다.");
      return false;
    }

    const file = e.target.files[0];
    const fileExt = file.name.split(".").pop(); // 파일 확장자

    console.log(file);
    console.log(fileExt);
    console.log(fileName);

    setFileName(file.name);
    setFile(file);
  };

  // 이용약관 읽음 여부

  const [readTermUse, setReadTermUse] = useState(false);
  const [readTermPrivacy, setReadTermPrivacy] = useState(false);

  return (
    <>
      <Head />
      <Header />
      <link rel="stylesheet" href="/css/join.min.css" />
      <div
        className="container"
        id="join"
        onClick={() => common.focusOutMenu()}
      >
        <content>
          <div className="input-form">
            <h3
              className="text-center fs-2 w-70"
              style={{ margin: "0 auto 17px" }}
            >
              기업 회원가입
            </h3>
            <p
              className="text-center fs-6 w-70"
              style={{ margin: "0 auto 12px" }}
            >
              회원가입하고 밈비와 함께 하세요
            </p>
            <a href="/registration">
              <p
                className="text-center fs-6 w-70 text-decoration-underline"
                style={{ margin: "0 auto 42px" }}
              >
                일반회원가입 하러가기
              </p>
            </a>

            <form className="validation-form" noValidate>
              <div id="twoLevel_left" class="w-100">
                <div className="row align-items-end">
                  <div className="col-9">
                    <input type="hidden" name="nickFlag" value=""></input>
                    <label htmlFor="nickName" className="form-label">
                      닉네임 <span className="required-icon">*</span>
                    </label>{" "}
                    <input
                      type="text"
                      className="form-control box"
                      id="nickname"
                      placeholder="Nickname"
                      value={nickName}
                      name="nickName"
                      onChange={handleChange}
                      required
                    />
                    <div className="invalid-feedback nickname">
                      *중복된 닉네임입니다. 다른 닉네임을 입력해주세요.
                    </div>
                  </div>
                  <div className="col-3">
                    <label htmlFor="nicknameCheck" className="form-label">
                      {" "}
                    </label>
                    <input
                      type="button"
                      className="w-100 btn basicBtn nickCheckBtn"
                      value="중복확인"
                      onClick={() => common.chk_nickname()}
                    />
                  </div>
                </div>
                <div className="row align-items-end">
                  <div className="col-9">
                    <label htmlFor="firstName" className="form-label">
                      이메일 <span className="required-icon">*</span>
                    </label>{" "}
                    <input
                      type="text"
                      className="form-control box"
                      id="userMail"
                      placeholder="Example@example.com"
                      value={userMail}
                      name="userMail"
                      onChange={handleChange}
                      required
                    />
                    <div className="invalid-feedback userMail">
                      *올바른 이메일을 입력해주세요.
                    </div>
                  </div>
                  <div className="col-3">
                    <input type="hidden" name="emailVerify" value=""></input>
                    <label htmlFor="userMailCheck" className="form-label">
                      {" "}
                    </label>
                    <input
                      type="button"
                      className="btn basicBtn sendEmail w-100"
                      value="인증받기"
                      onClick={() => common.email_send()}
                    />
                    <div className="email-verificate">
                      <input
                        type="text"
                        className="box mt-2 mb-2"
                        name="code"
                        value={code}
                        placeholder="Enter code"
                        onChange={handleChange}
                        style={{ margin: ".5rem 0px" }}
                      />
                      <input
                        type="button"
                        className="btn basicBtn w-100"
                        value="인증완료"
                        style={{ margin: ".5rem 0px" }}
                        onClick={() => common.verifyCode()}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="pw" className="form-label">
                    비밀번호 <span className="required-icon">*</span>
                  </label>{" "}
                  <input
                    type="password"
                    className="form-control box"
                    id="pw"
                    name="pw"
                    placeholder="비밀번호 입력"
                    minLength="6"
                    value={pw}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="password"
                    id="pw_cf"
                    name="pw_cf"
                    className="form-control box"
                    placeholder="비밀번호 확인"
                    minLength="6"
                    value={pw_cf}
                    maxlength="20"
                    onChange={handleChange}
                    required
                  />
                  <div className="invalid-feedback pw">
                    *6자 이상 입력해주세요
                  </div>
                  <div className="invalid-feedback pw_cf">
                    *비밀번호가 일치하지 않습니다.
                  </div>
                </div>
              </div>
              <div className="twoLevel_right w-100">
                <div className="mb-3">
                  <label htmlFor="referralCodes" className="form-label">
                    사업자 등록증 사본 <span className="required-icon">*</span>
                  </label>
                  <div class="upload-drag-box">
                    <input
                      type="hidden"
                      id="fileName"
                      name="fileName"
                      value={fileName}
                    />
                    <input
                      type="hidden"
                      id="uploadUrl"
                      name="uploadUrl"
                      value={uploadUrl}
                    />

                    <input
                      type="file"
                      name="file"
                      placeholder="사업자등록증을 올려주세요.(5MB 미만)"
                      required
                      onChange={handleFileInput}
                      accept="image/*,application/pdf"
                    />
                  </div>
                  <div className="invalid-feedback biz_file">
                    *사업자등록증을 업로드해주세요(5MB 미만)
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="businessNumber" className="form-label">
                    사업자 번호 <span className="required-icon">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control box"
                    id="businessNumber"
                    name="businessNumber"
                    placeholder=""
                    value={businessNumber}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback biz_number">
                    *사업자 번호를 입력해주세요
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="callNumber" className="form-label">
                    대표번호 <span className="required-icon">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control box"
                    id="callNumber"
                    name="callNumber"
                    placeholder=""
                    value={callNumber}
                    onChange={handleChange}
                  />
                  <div className="invalid-feedback biz_call">
                    *대표번호를 입력해주세요
                  </div>
                </div>

                {/* <div className="row align-items-end">
                                    <div className="col-9">
                                        <label htmlFor="referralCodes" className="form-label">추천인ID</label>
                                        <input
                                            type="text" className="form-control box" id="inviterEmail"
                                            placeholder="추천인ID 입력" value={inviterEmail} name="inviterEmail" onChange={handleChange} />
                                    </div>
                                    <div className="col-3">
                                        <input type="hidden" name="inviterEmailVerify" value={inviterEmailVerify}></input>
                                        <label htmlFor="userMailCheck" className="form-label"> </label>
                                        <button type="button" className="btn basicBtn sendUserMailCheck w-100" onClick={checkInviterEmail}>Check</button>
                                    </div>
                                </div> */}
              </div>
              <div id="twoLevel_bottom">
                <div className="mb-3 term-box">
                  <input
                    type="checkbox"
                    id="privacyTerm1"
                    name="privacyTerm1"
                    className="m-2"
                    required
                  />
                  <label htmlFor="privacyTerm1"></label>
                  <span onClick={() => $("#privacyTerm1").trigger("click")}>
                    <b>
                      <a
                        onClick={() =>
                          window.open(
                            "/terms/termsOfUse",
                            "[밈비]이용약관",
                            "width=600, height=700, location=no,status=no, scrollbars=yes"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        이용약관
                      </a>
                    </b>{" "}
                    및{" "}
                    <b>
                      <a
                        onClick={() =>
                          window.open(
                            "/terms/termsOfPrivacy",
                            "[밈비]개인정보처리방침",
                            "width=600, height=700, location=no,status=no, scrollbars=yes"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        개인정보 처리방침
                      </a>
                    </b>
                    에 동의합니다.
                  </span>
                  <div className="invalid-feedback pw_cf">
                    *필수 약관에 동의해주세요.
                  </div>
                </div>
                <div className="mb-3 term-box">
                  <input
                    type="checkbox"
                    id="privacyTerm2"
                    name="privacyTerm2"
                    className="m-2"
                    required
                  />
                  <label htmlFor="privacyTerm2"></label>
                  <span onClick={() => $("#privacyTerm2").trigger("click")}>
                    19세 이상임을 확인합니다.
                  </span>
                  <div className="invalid-feedback pw_cf">
                    *필수 약관에 동의해주세요.
                  </div>
                </div>
              </div>

              <hr className="my-4" />
              <button
                className="w-100 btn btn-lg btn-primary basicBtn mr-3"
                id="createAccountBtn"
                type="button"
                onClick={joinFunc}
              >
                회원가입
              </button>
            </form>
          </div>
        </content>
      </div>
      <Footer />
      <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
    </>
  );
};

export default RegistrationCorp;
